

/// <reference path="../AppHelper.ts" />

class SupplierProductViewController extends MUIViewController
{    
    private searchTextField:MUITextField = null;
    private onlySupplierProducts:MUISwitchButton = null;
    private emailOrdersTextField:MUITextField = null;
    private tableView:UITableView = null;    
    
    private searchTimer = null;
    private searchString = null;    

    private cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter;
    
    viewDidLoad(){
        super.viewDidLoad();
        
        this.onlySupplierProducts = MUIOutlet(this, 'supplier-only-products-sw','MUISwitchButton');
        this.onlySupplierProducts.setOnChangeValue(this, function(control, value){
            this._supplier.onlySupplierProducts = value;
        });

        this.searchTextField = MUIOutlet(this, 'search-bar','MUITextField');
        this.searchTextField.setOnChangeText(this, function(textfield, value){
            this.searchString = value.length > 0 ? value : null;

            if (this.searchTimer != null) this.searchTimer.invalidate();
            this.searchTimer = MIOTimer.scheduledTimerWithTimeInterval(500, false, this, function(tinmer:MIOTimer){
                this.fetchedResultsController = null;
                this.tableView.reloadData();
            });
        });     

        this.emailOrdersTextField = MUIOutlet(this, "email-orders-tf", "MUITextField");
        this.emailOrdersTextField.setOnChangeText(this, function(this:SupplierProductViewController, control:MUITextField, value:string){
            this._supplier.emailOrders = value.length > 0 ? value : null;
        });
        
        this.tableView = MUIOutlet(this, 'table-view', 'UITableView');
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);        
        this.updateUI();
    }

    private _supplier:Supplier = null;
    set supplier(value){
        this._supplier = value;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._supplier == null) return;

        this.onlySupplierProducts.setOn(this._supplier.onlySupplierProducts);
        this.emailOrdersTextField.text = this._supplier.emailOrders;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length + 1;
    }
    
    numberOfRowsInSection( tableView:UITableView, section:number ){
        if ( section == this.fetchedResultsController.sections.length ) return 1;

        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }
    
    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){

        let cell:SupplierProductCell = null;
        if (indexPath.section == this.fetchedResultsController.sections.count) {
            cell = tableView.dequeueReusableCellWithIdentifier('AddCell') as SupplierProductCell;            
        }
        else {
            cell = tableView.dequeueReusableCellWithIdentifier('EditCell') as SupplierProductCell;
    
            let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as SupplierProduct;    
            cell.item = item;    
        }

        cell.supplier = this._supplier;
        return cell;
    }        

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        if (indexPath.section == this.fetchedResultsController.sections.count) return UITableViewCellEditingStyle.Insert;

        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {

        if (editingStyle == UITableViewCellEditingStyle.Delete){
            let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as SupplierProduct;
            DBHelper.removeSupplierProduct(item, true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;    
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey('product.name', true) ];
        let predicateFormat = 'supplier.identifier == ' + this._supplier.identifier;

        if(this.searchString != null)
            predicateFormat += " AND product.name CONTAINS '" + this.searchString + "'";

        let fetchRequest = DBHelper.listFetchRequestWithEntityName('SupplierProduct', sortDescriptors, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ['product'];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeObject(controller: MIOFetchedResultsController, object: any, indexPath: MIOIndexPath, changeType: MIOFetchedResultsChangeType, newIndexPath: MIOIndexPath)  {

        switch(changeType){
            case MIOFetchedResultsChangeType.Insert:
            this.tableView.insertRowsAtIndexPaths([newIndexPath], UITableViewRowAnimation.Automatic);
            break;

            case MIOFetchedResultsChangeType.Delete:
            this.tableView.deleteRowsAtIndexPaths([indexPath], UITableViewRowAnimation.Automatic);
            break;
        }

    }

    // controllerDidChangeContent(controller){
    //     this.tableView.reloadData();
    // }
}
